<script setup>
import DonutCardsWrapper from '@/widgets/statistics/components/DonutCardsWrapper.vue'
import LineChart from '@/__v1.5__/components/charts/line-chart/LineChart.vue'
import { computed, inject } from 'vue'
import { loc } from '@/__core__/localization/localization'
import GameStatsSkeleton from '@/__v1.5__/composits/game-stats/GameStatsSkeleton.vue'

const props = defineProps({
  stats: {
    type: Object,
    default: () => ({})
  }
})

const langId = inject('langId')
const status = inject('status')

const isDonutVisible = computed(() => !![...Object.keys(props.stats.home), ...Object.keys(props.stats.away)].length)

const STATS_TEMPLATE = ['free_kicks', 'fouls_committed', 'offsides', 'shots', 'shot_on_target', 'shot_off_target', 'corners', 'shots_saved']

const statistics = computed(() => {
  const stats = []

  if (!Object.keys(props.stats.home).length || !Object.keys(props.stats.away).length) {
    return stats
  }

  const teamFactory = (label, additionalLabel, value) => ({ label, additionalLabel, value })
  const calculatePercentage = (value, totalValue) => ((value / totalValue) * 100).toFixed(2)

  for (const category of STATS_TEMPLATE) {
    const { label, value: homeValue } = props.stats.home[category]
    const { value: awayValue } = props.stats.away[category]

    let stat = {
      uuid: category,
      home: teamFactory('-', '', 0),
      away: teamFactory('-', '', 0),
      title: loc(label, langId),
      isDisabled: true,
      isUncovered: true
    }

    if (homeValue && awayValue) {
      const homeValueNumber = Number(homeValue)
      const awayValueNumber = Number(awayValue)

      const totalValue = homeValueNumber + awayValueNumber

      const homePercentage = calculatePercentage(homeValueNumber, totalValue)
      const awayPercentage = calculatePercentage(awayValueNumber, totalValue)

      stat = {
        uuid: category,
        home: teamFactory(`${homeValueNumber}`, '', homePercentage),
        away: teamFactory(`${awayValueNumber}`, '', awayPercentage),
        title: loc(label, langId),
        isDisabled: !homeValueNumber && !awayValueNumber,
        isUncovered: homeValueNumber === 0 && awayValueNumber === 0
      }
    }

    stats.push(stat)
  }

  return stats
})
</script>

<template>
  <div class="szw-flex szw-flex-col szw-h-full szw-w-full szw-max-w-[768px] szw-items-center szw-gap-1 szw-mx-auto">
    <game-stats-skeleton v-if="status === 'loading'" />

    <template v-else>
      <donut-cards-wrapper v-if="isDonutVisible" :home-stats="stats.home" :away-stats="stats.away" />

      <line-chart v-for="stat of statistics" :key="stat.uuid" v-bind="stat" />
    </template>
  </div>
</template>
